module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-page-wrapper aboutpage",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "over-lay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row aboutrow"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "main-content"
  }, [_c('h2', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("About Us")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 col-sm-offset-2",
    staticStyle: {
      "text-align": "left"
    }
  }, [(_vm.beginSectionHeading) ? _c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.beginSectionHeading))]) : _vm._e(), _vm._v(" "), (_vm.beginSectionPara1) ? _c('p', {
    staticStyle: {
      "text-align": "left"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.beginSectionPara1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.beginSectionPara2) ? _c('p', {
    staticStyle: {
      "text-align": "left"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.beginSectionPara2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.beginSectionPara3) ? _c('p', {
    staticStyle: {
      "text-align": "left"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.beginSectionPara3)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.beginSectionImage) ? _c('div', {
    staticClass: "col-sm-4 toneleftlogo"
  }, [_c('div', {
    staticClass: "aboutlogoholder"
  }, [_c('img', {
    staticStyle: {
      "height": "508px",
      "width": "315px"
    },
    attrs: {
      "src": _vm.beginSectionImage,
      "alt": "CEO IMAGE",
      "title": "Gemma Toner"
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 mtop30 col-sm-offset-2"
  }, [(_vm.createdSectionHeading) ? _c('h4', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v(_vm._s(_vm.createdSectionHeading))]) : _vm._e(), _vm._v(" "), (_vm.createdSectionPara1) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.createdSectionPara1)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.createdSectionPara2) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.createdSectionPara2)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.createdSectionPara3) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.createdSectionPara3)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [(_vm.bottomMessage1) ? _c('h4', {
    staticClass: "welcomemessage",
    style: ({
      color: _vm.getCorpHeadingColor
    }),
    domProps: {
      "innerHTML": _vm._s(_vm.bottomMessage1)
    }
  }) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "welcomemessage",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('b', [_vm._v(_vm._s(_vm.bottomMessage2))]), _c('br'), _vm._v(" "), _c('small', [_vm._v(_vm._s(_vm.bottomMessage3))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.staffMembers) ? _c('div', {
    staticClass: "slider responsive-slick-imagelist"
  }, _vm._l((_vm.staffMembers), function(member) {
    return _c('div', {
      staticClass: "slide-player"
    }, [_c('img', {
      attrs: {
        "src": member.memberImageUrl,
        "alt": member.memberFirstName,
        "title": member.memberFirstName
      }
    }), _vm._v(" "), _c('h4', {
      staticClass: "text-center",
      style: ({
        color: _vm.getCorpHeadingColor
      })
    }, [_vm._v(_vm._s(member.memberFirstName)), _c('br'), _c('small', [_vm._v(_vm._s(member.position))])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(member.biography))])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "contactformtexttone contact-form"
  }, [_c('a', {
    attrs: {
      "href": "javascript:"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/become-expert')
      }
    }
  }, [_c('h3', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("Want to become a TONE Expert?")])])])])])
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08b77c3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/AboutUs.vue